'use client';

import { useSitePhotoArchiveEditor } from "@/app/features/sites/photo-archive/contexts/SitePhotoArchiveEditorContext";
import RelatedInfosView from "@/app/features/shared/related-infos/ui/RelatedInfos.public";
import { RelatedInfo } from "@/app/lib/generated/graphql-types";

export default function PhotoArchiveRelatedInfosEditable() {
    const {
        editable,
    } = useSitePhotoArchiveEditor();

    if (!editable) {
        return null;
    }

    if (editable.relatedInfos.length === 0) {
        return null;
    }

    return <RelatedInfosView relatedInfos={editable.relatedInfos as RelatedInfo[]} />
}
